module.exports = __webpack_public_path__ + "static/media/backArrow.660bd0ba.svg";